import React from 'react';
import { Button } from 'antd';
import { Modal } from 'ui';
import { FormattedMessage } from 'react-intl';
import SubmissionDetail from 'components/AssignmentActivity/SubmissionDetail';

interface CertModalInterface {
    open: boolean;
    onCancel: React.Dispatch<React.SetStateAction<boolean>>;
    submission: any;
}

const CertModal: React.FC<CertModalInterface> = ({ open, onCancel, submission }) => {
    return (
        <Modal
            open={open}
            width={'600px'}
            onCancel={() => onCancel(false)}
            className="add_remove_activity"
            title={submission.title}
            destroyOnClose={true}
            footer={
                <Button onClick={() => onCancel(false)}>
                    <FormattedMessage id="general.close" />
                </Button>
            }
        >
            <SubmissionDetail submission={submission} />
        </Modal>
    );
};

export default CertModal;
